import React from 'react';
import { Link } from 'react-router-dom';

function OakMark({ className = 'h-9 w-9' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="24" cy="24" r="23" className="fill-oak-900" />
      <path
        d="M24 10c-1.2 3.8-2 7.2-2.2 10.2 0 0-5.8-2.4-8.8-6.1 3.6 1.1 6.4 3.2 8.2 5.8C20.4 16.4 21.8 13 24 10z"
        className="fill-claire-300"
      />
      <path
        d="M24 10c1.2 3.8 2 7.2 2.2 10.2 0 0 5.8-2.4 8.8-6.1-3.6 1.1-6.4 3.2-8.2 5.8C27.6 16.4 26.2 13 24 10z"
        className="fill-oak-300"
      />
      <path
        d="M21.8 20.4c-3.4.8-6.8 2.8-9.3 5.8 3.2-.2 6.4.2 9.1 1.6-1.1-2.4-1.1-5 .2-7.4z"
        className="fill-claire-400"
      />
      <path
        d="M26.2 20.4c3.4.8 6.8 2.8 9.3 5.8-3.2-.2-6.4.2-9.1 1.6 1.1-2.4 1.1-5 .2-7.4z"
        className="fill-oak-400"
      />
      <path
        d="M24 22.2c-1.4 2.8-1.6 5.6-.8 8.2.8-2.6.8-5.4 0-8.2 0 0-3.6 3.4-4.8 7.2 2.2-1 4-1.4 5.6-1.4s3.4.4 5.6 1.4c-1.2-3.8-4.8-7.2-4.8-7.2h-0.8z"
        className="fill-oak-100"
      />
      <path
        d="M24 30.2v8"
        className="stroke-oak-100"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function ClaireoaksLogo({ className = '', compact = false, light = false }) {
  return (
    <Link
      to="/"
      className={`group flex items-center gap-2.5 ${className}`.trim()}
      aria-label="Claireoaks Credit Union home"
    >
      <OakMark className="h-9 w-9 shrink-0 transition-transform duration-300 group-hover:scale-105 sm:h-10 sm:w-10" />
      <span className="flex min-w-0 flex-col leading-none">
        <span
          className={`font-display text-xl font-semibold tracking-tight sm:text-2xl ${
            light ? 'text-white' : 'text-oak-900'
          }`}
        >
          Claireoaks
        </span>
        {!compact ? (
          <span
            className={`mt-0.5 text-[10px] font-medium uppercase tracking-[0.22em] sm:text-[11px] ${
              light ? 'text-claire-200' : 'text-claire-600'
            }`}
          >
            Credit Union
          </span>
        ) : null}
      </span>
    </Link>
  );
}

export { OakMark };
